import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { HealthCheckService } from "src/app/services/health-check.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { CalendarUtilityService } from "src/app/services/calendar-utility.service";
import { Console } from "console";
import {
  AllHospitals,
  HospitalList,
  TopHospitalList,
} from "src/app/models/common-model";
import {
  BookHealthCheck,
  LstHealthCheckListAngularAdmin,
  SlotTimeData,
  SlotTimeV2,
} from "src/app/models/health-check-types.model";
@Component({
  selector: "app-ask-apollo-create-hcappointments",
  templateUrl: "./ask-apollo-create-hcappointments.component.html",
  styleUrls: ["./ask-apollo-create-hcappointments.component.scss"],
})
export class AskApolloCreateHCAppointmentsComponent
  implements OnInit, OnDestroy
{
  selectedUHIDDetails: any;
  isNewUser: boolean = false;
  callType: number;
  loadingFlag: boolean = false;
  submitted: boolean;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;

  resetPkgEnquiryForm: boolean;
  //objects
  citiesData: any[];
  clinicsData: any[];
  specialitiesData: any[];
  // doctorsData: any[];
  datesData: any[];
  slotsTimeObj: SlotTimeData;
  slotsData: SlotTimeV2[];
  apptRequestModes: any[];
  //rescheduleDetails:any[];
  isAppointmentCreatedSuccessfully = false;
  callerStatusAutoId = 0;
  isSelectedCallBackOption = false;
  isInboundCallNewUser = false;
  isSelectedStatusUpdate = false;
  isSelectedAppointment = false;
  selectedCallStatusName;
  selectedCallStatusId;
  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  selectedCity;
  selectedHospital;
  selectedSpeciality;
  // selectedDoctor;
  selectedDate;
  yearRangeDob = "";
  dobMaxDate: Date;
  callBackMinimumDate = new Date();
  HcApptsData: Subscription;
  currentUser: [];

  constructor(
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private calendarService: CalendarUtilityService,
    private healthCheckService: HealthCheckService,
    private commonService: CommonService
  ) {
    let date = new Date();
    this.dobMaxDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 1
    );
    this.yearRangeDob = `${date.getFullYear() - 100}:${date.getFullYear()}`;
  }
  createAppointmentForm: FormGroup;
  callStatusForm: FormGroup;
  ngOnInit() {
    this.createAppointmentForm = this.formBuilder.group({
      patientFirstName: ["", Validators.required],
      patientLastName: ["", Validators.required],
      dateOfBirth: ["", Validators.required],
      gender: ["", [Validators.required, Validators.min(1)]],
      maritalStatusId: ["", Validators.required],
      // relationTypeId: ['', Validators.required],
      salutation: ["", [Validators.required, Validators.min(1)]],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
          ),
        ],
      ],
      patientMobileNumber: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      // mobileNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      // appointmentType: ['', Validators.required],
      city: ["", [Validators.required, Validators.min(1)]],
      clinic: ["", [Validators.required, Validators.min(1)]],
      speciality: ["", [Validators.required, Validators.min(1)]],
      // doctor: ['', [Validators.required, Validators.min(1)]],
      appointmentDate: ["", Validators.required],
      appointmentSlot: ["", [Validators.required, Validators.min(1)]],
      appointmentReqMode: ["", [Validators.required, Validators.min(1)]],
      statusRemarks: [""],
    });

    // this.callStatusForm = this.formBuilder.group({
    //   callBackDate: [''],
    //   callBackTime: [''],
    //   remarks: ['', Validators.required],
    //   subDisposition: ['',[Validators.required, Validators.min(1)]],
    // });

    this.CheckPrimaryCases();
  }

  ngOnDestroy() {
    this.HcApptsData.unsubscribe();
  }

  leadId;
  CheckPrimaryCases() {
    //this method get the selected call status data from service
    this.HcApptsData = this.callCenterService.selectedCallStatus.subscribe(
      (value) => {
        this.leadId = value.LeadId;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.callerStatusAutoId = value.CallerStatusAutoId;
        this.selectedUHIDDetails = value.UHIDDetails;
        // this.rescheduleDetails = value.RescheduleDetails;
        this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
        this.selectedCallStatusName = value.CallStatus["statusName"];
        if (
          this.selectedCallStatusId == 35 &&
          this.callType == 1 &&
          this.isNewUser
        ) {
          // inbound new user + create appt
          console.log("Inbound new user");
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = true;
          this.loadBasicDetailsOfLead();
          this.getAllCities(); //this.selectedAppointmentType
        } else if (this.selectedCallStatusId == 35) {
          //outbound+inbound existed user or new user.
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = false;
          if (this.isNewUser && this.callType == 2) {
            // for lead new user in outbound call only
            this.loadBasicDetailsOfLead();
          } else {
            this.loadBasicDetails();
          }
          this.getAllCities(); //this.selectedAppointmentType
        }
        //load appt reuqest modes
        // this.getApptRequestModes(); //old
        this.getAllLeadSources();
      }
    );
  }

  subDispositionsData = [];
  getSubDispositionsData(callStatusId) {
    this.commonService.FetchAllSubDispositions(callStatusId).subscribe(
      (res: any) => {
        if (res && res.response && res.response.length > 0) {
          console.log("dis", res);
          this.subDispositionsData = res.response;
        } else {
          this.subDispositionsData = [];
        }
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve sub dispositions data from server "
        );
      }
    );
  }

  loadBasicDetailsOfLead() {
    //debugger
    if (this.selectedUHIDDetails.firstName) {
      this.createAppointmentForm.controls["patientFirstName"].setValue(
        this.selectedUHIDDetails.firstName
      );
      //this.createAppointmentForm.controls["patientFirstName"].disable();
    }
    if (this.selectedUHIDDetails.lastName) {
      this.createAppointmentForm.controls["patientLastName"].setValue(
        this.selectedUHIDDetails.lastName
      );
      //this.createAppointmentForm.controls["patientLastName"].disable();
    }
    if (
      (this.selectedUHIDDetails["gender"] &&
        this.selectedUHIDDetails["gender"].toLowerCase() == "male") ||
      this.selectedUHIDDetails["gender"].toLowerCase() == "female"
    ) {
      this.createAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails["gender"].toLowerCase() == "male" ? "1" : "2"
      );
      //this.createAppointmentForm.controls["gender"].disable();
    }
    if (this.selectedUHIDDetails.emailId) {
      this.createAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
      //this.createAppointmentForm.controls["email"].disable();
    }
    if (this.selectedUHIDDetails.phoneNo) {
      this.createAppointmentForm.controls["patientMobileNumber"].setValue(
        this.selectedUHIDDetails.phoneNo
      );
      // this.createAppointmentForm.controls["mobileNumber"].setValue(this.selectedUHIDDetails.phoneNo)
      //this.createAppointmentForm.controls["patientMobileNumber"].disable();
    }
  }

  loadBasicDetails() {
    if (this.selectedUHIDDetails.firstName) {
      this.createAppointmentForm.controls["patientFirstName"].setValue(
        this.selectedUHIDDetails.firstName
      );
      this.createAppointmentForm.controls["patientFirstName"].disable();
    }
    if (this.selectedUHIDDetails.lastName) {
      this.createAppointmentForm.controls["patientLastName"].setValue(
        this.selectedUHIDDetails.lastName
      );
      this.createAppointmentForm.controls["patientLastName"].disable();
    }
    if (
      this.selectedUHIDDetails.gender == 1 ||
      this.selectedUHIDDetails.gender == 2
    ) {
      this.createAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails.gender + ""
      );
      this.createAppointmentForm.controls["gender"].disable();
    }

    if (this.selectedUHIDDetails.dateOfBirth) {
      let dob = this.selectedUHIDDetails.dateOfBirth.split("/");
      this.createAppointmentForm.controls["dateOfBirth"].setValue(
        new Date(dob[2], dob[1] - 1, dob[0])
      );
      this.createAppointmentForm.controls["dateOfBirth"].disable();
    }
    if (this.selectedUHIDDetails.maritalStatus != 0) {
      this.createAppointmentForm.controls["maritalStatusId"].setValue(
        this.selectedUHIDDetails.maritalStatus
      );
      this.createAppointmentForm.controls["maritalStatusId"].disable();
    }
    if (this.selectedUHIDDetails.salutation != 0) {
      this.createAppointmentForm.controls["salutation"].setValue(
        this.selectedUHIDDetails.salutation
      );
      this.createAppointmentForm.controls["salutation"].disable();
    }
    if (this.selectedUHIDDetails.emailId) {
      this.createAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
      this.createAppointmentForm.controls["email"].disable();
    }
    if (
      this.selectedUHIDDetails.phoneNo ||
      this.selectedUHIDDetails.mobileNumber
    ) {
      this.createAppointmentForm.controls["patientMobileNumber"].setValue(
        this.isNewUser
          ? this.selectedUHIDDetails.phoneNo
          : this.selectedUHIDDetails.mobileNumber
      );
      // this.createAppointmentForm.controls["mobileNumber"].setValue(this.isNewUser ? this.selectedUHIDDetails.phoneNo : this.selectedUHIDDetails.mobileNumber)
      this.createAppointmentForm.controls["patientMobileNumber"].disable();
    }
  }

  getAllCities() {
    this.citiesData = [];
    this.clinicsData = [];
    this.specialitiesData = [];
    // this.doctorsData = [];
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1000, 1, 1);
    this.apptMaximumDate = new Date(1000, 1, 1);
    this.disableOrEnableForm(0);
    this.healthCheckService.getCities().subscribe(
      (res) => {
        // this.commonService.loadingHide();
        let top = [],
          cities = [];
        if (res && res.citiesList && res.citiesList.length > 0) {
          if (res && res.topCitiesList && res.topCitiesList.length > 0) {
            top = res.topCitiesList;
          }
          if (res && res.citiesList && res.citiesList.length > 0) {
            cities = res.citiesList;
          }
          // this.citiesData = [...top, ...cities];
          this.citiesData = cities;
        }
        this.disableOrEnableForm(1);
      },
      (err) => {
        // this.commonService.loadingHide();
        this.disableOrEnableForm(1);
      }
    );
  }

  CityByName(index, item) {
    return item.name;
  }

  //Hospitals
  allHospitals: AllHospitals;
  topHospitals: TopHospitalList[];
  HospitalsList: HospitalList[];
  hospitals: HospitalList[] = [];
  clinics: HospitalList[] = [];
  getClinicsOnCityId(cityId) {
    this.clinicsData = [];
    this.specialitiesData = [];
    // this.doctorsData = [];
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1000, 1, 1);
    this.apptMaximumDate = new Date(1000, 1, 1);
    this.createAppointmentForm.get("clinic").setValue("");
    this.createAppointmentForm.get("speciality").setValue("");
    // this.createAppointmentForm.get('doctor').setValue('');
    this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    // this.selectedDoctor = -1;
    this.topHospitals = [];
    this.HospitalsList = [];
    this.hospitals = [];
    this.clinics = [];
    let appointmentType = 3;
    this.disableOrEnableForm(0);
    this.healthCheckService.getHospitals(cityId, appointmentType).subscribe(
      (res) => {
        this.disableOrEnableForm(1);
        if (res && res.hospitalList && res.hospitalList.length > 0) {
          this.HospitalsList = res.hospitalList;
        } else {
          this.messageService.showErrorMessage("No hospitals found.");
        }
      },
      (error) => {
        this.disableOrEnableForm(1);
        this.messageService.showErrorMessage(
          "Unable to load hospitals. Please Contact Admin."
        );
      }
    );
  }

  HosipitalByName(index, item) {
    return item.name;
  }

  //Health Check Type
  healthChekTypes: LstHealthCheckListAngularAdmin[];
  healthChekDetails: LstHealthCheckListAngularAdmin;
  getHealthChecksBasedOnHospitalId(selectedHospital) {
    this.healthChekTypes = [];
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1000, 1, 1);
    this.apptMaximumDate = new Date(1000, 1, 1);
    this.createAppointmentForm.get("speciality").setValue("");
    // this.bookForm.get('tariff').setValue('');
    this.selectedHospital = selectedHospital;
    if (selectedHospital) {
      let data = {
        HospitalId: selectedHospital,
        isAHCPortalIntegrated: true,
      };

      this.disableOrEnableForm(0);
      this.healthCheckService.GetHealthChecksByHospitalIdv2(data).subscribe(
        (res) => {
          // debugger
          this.disableOrEnableForm(1);
          if (
            res &&
            res.lstHealthCheckListAngular &&
            res.lstHealthCheckListAngular.length > 0
          ) {
            this.healthChekTypes = res.lstHealthCheckListAngular;
          } else {
            this.messageService.showErrorMessage("No Health Checks found.");
          }
        },
        (error) => {
          this.disableOrEnableForm(1);
          this.messageService.showErrorMessage(
            "Unable to load Health checks. Please Contact Admin."
          );
        }
      );
    }
  }

  isNoDatesAvailable = true;
  getDates(hcId) {
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1000, 1, 1);
    this.apptMaximumDate = new Date(1000, 1, 1);
    this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    // this.selectedDoctor = -1
    if (hcId) {
      this.healthChekDetails = this.healthChekTypes.filter(
        (h) => h.HealthCheckId == hcId
      )[0];
      this.disableOrEnableForm(0);
      this.datesData = [];
      let data = {
        hospitalId: +this.selectedHospital, //57
        healthCheckId: +this.healthChekDetails.HealthCheckId, //269
      };

      this.healthCheckService
        .getHealthCheckDates(data) // hospitalid, doctorId
        .subscribe(
          (res: any) => {
            // debugger
            if (res.name && res.name.length > 0) {
              //this.datesData = res.response;
              this.isNoDatesAvailable = false;
              this.disableApptDates(res.name);
            } else {
              this.isNoDatesAvailable = true;
              this.datesData = [];
              this.slotsData = [];
              this.invalidApptDates = [];
              this.messageService.showErrorMessage(
                "No dates available for selected HC."
              );
            }
            this.ref.detectChanges();
            this.disableOrEnableForm(1);
          },
          (error) => {
            // this.messageService.showError();
            this.messageService.showErrorMessage(
              "Unable to load dates. Please Contact Admin."
            );
            this.disableOrEnableForm(1);
          }
        );

      // this.isNoDatesAvailable = false;
      // let temp="2021-6-23,2021-6-24,2021-6-25,2021-6-26,2021-6-28,2021-6-29,2021-6-30,2021-7-1,2021-7-2,2021-7-3,2021-7-5,2021-7-6,2021-7-7,2021-7-8,2021-7-9,2021-7-10,2021-7-12,2021-7-13,2021-7-14,2021-7-15,2021-7-16,2021-7-17,2021-7-19,2021-7-20,2021-7-21,2021-7-22,2021-7-23,2021-7-24,2021-7-26,2021-7-27,2021-7-28,2021-7-29,2021-7-30,2021-7-31,2021-8-2,2021-8-3,2021-8-4,2021-8-5,2021-8-6,2021-8-7,2021-8-9,2021-8-10,2021-8-11,2021-8-12,2021-8-13,2021-8-14,2021-8-16,2021-8-17,2021-8-18,2021-8-19,2021-8-20,2021-8-21";
      // this.disableApptDates(temp)
    }
  }

  apptMaximumDate = new Date();
  apptMinimumDate = new Date();
  invalidApptDates: Date[];
  tempDates: Date[];
  disableApptDates(enableDates) {
    //enableDates = "2020-5-14,2020-5-18,2020-5-19,2020-5-20,2020-5-21,2020-5-25,2020-5-26,2020-5-27,2020-5-30,2020-6-1,2020-6-2,2020-6-3,2020-6-4,2020-6-5,2020-6-6,2020-6-11,2020-6-12,2020-6-13,2020-6-15,2020-6-16,2020-6-19,2020-6-20,2020-6-22,2020-6-23,2020-6-24,2020-6-25,2020-6-26,2020-6-27,2020-6-29,2020-6-30,2020-7-1,2020-7-2,2020-7-3,2020-7-4,2020-7-6,2020-7-7,2020-7-8,2020-7-9,2020-7-10,2020-7-11,2020-7-13,2020-7-14,2020-7-15,2020-7-16,2020-7-17,2020-7-18,2020-7-20,2020-7-21,2020-7-22,2020-7-23,2020-7-24,2020-7-25,2020-7-27,2020-7-28,2020-7-29,2020-7-30,2020-7-31,2020-8-1,2020-8-3,2020-8-4,2020-8-5,2020-8-6,2020-8-7,2020-8-8,2020-8-14,2020-8-15,2020-8-17,2020-8-18,2020-8-19,2020-8-20,2020-8-21,2020-8-22,2020-8-24,2020-8-29,2020-8-31";
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1000, 1, 1);
    this.apptMaximumDate = new Date(1000, 1, 1);
    this.datesData = enableDates ? enableDates.split(",") : [];
    let tempDates = [];
    // debugger
    for (let i = 0; i < this.datesData.length; i++) {
      let dArr = this.datesData[i].split("/");
      let dd = dArr[2] + "-" + dArr[1] + "-" + dArr[0];
      tempDates.push(dd);
    }
    this.datesData = tempDates;
    if (this.datesData.length > 0) {
      this.datesData.sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );
      this.apptMaximumDate = new Date(
        this.datesData[this.datesData.length - 1]
      );
      this.apptMinimumDate = new Date(this.datesData[0]);
      this.tempDates = [];
      this.datesData.forEach((d) => {
        this.tempDates.push(new Date(d));
      });
      this.invalidApptDates = this.calendarService.getDisabledDates(
        this.tempDates
      );
      console.log(this.invalidApptDates, ".DDD..", this.tempDates);
      console.log(this.apptMinimumDate, "...", this.apptMinimumDate);
      this.ref.detectChanges();
    } else {
      this.invalidApptDates = [];
      this.messageService.showErrorMessage(
        "No dates available for selected HC."
      );
    }
  }

  allSlotsData = [];
  selectedAppointmentDate = "";
  getSlots(apptDate) {
    this.allSlotsData = [];
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = dd.getMonth() + 1 + "";
    let year = dd.getFullYear();
    apptDate =
      (date.length == 1 ? "0" + date : date) +
      "-" +
      (month.length == 1 ? "0" + month : month) +
      "-" +
      year;
    this.selectedAppointmentDate = apptDate;
    if (this.selectedHospital > 0 && apptDate) {
      let data = {
        hospitalId: +this.selectedHospital,
        healthCheckId: Number(this.healthChekDetails.HealthCheckId),
        appointmentDate: apptDate,
        // "isAngularRequest": true,
        // "isProHealthCheck": false
      };
      this.disableOrEnableForm(0);
      this.healthCheckService.getHealthCheckSlots(data).subscribe(
        (res: any) => {
          this.slotsTimeObj = res;
          if (res.hcSlots && res.hcSlots.length > 0)
            this.slotsData = res.hcSlots;
          this.disableOrEnableForm(1);
        },
        (error) => {
          if (error.status == 400) {
            this.messageService.showErrorMessage(error.error.Message);
          } else {
            this.messageService.showErrorMessage(
              "Unable to load slots on selected date."
            );
          }
          this.disableOrEnableForm(1);
        }
      );
    }
    // this.slotsData = [{SlotId: -1, SlotTime: "07:00-07:45"}]
  }

  SlotsByTime(index, item) {
    return item.SlotTime;
  }

  slotsChangeEvent(ee) {
    console.log(JSON.stringify(ee.target.value));
  }

  getApptRequestModes() {
    this.disableOrEnableForm(0);
    this.apptRequestModes = [];
    this.callCenterService.getApptRequestModes().subscribe(
      (res: any) => {
        // console.log("dates:", res);
        if (res.response.length > 0) {
          this.apptRequestModes = res.response;
        }
        this.disableOrEnableForm(1);
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve Appt Requests data from server "
        );
        this.disableOrEnableForm(1);
      }
    );
  }

  leadSources: any = [];
  getAllLeadSources() {
    this.commonService.getAllLeadSources().subscribe(
      (res: any) => {
        if (res.response.length > 0) {
          // this.leadSources = res.response;
          this.apptRequestModes = res.response;
        } else {
          this.apptRequestModes = [];
          this.disableOrEnableForm(1);
        }
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve leadsource data from server "
        );
        this.disableOrEnableForm(1);
      }
    );
  }

  ApptRequestModesByName(index, item) {
    return item.name;
  }
  /* 
  bookAppointment(formDataValues) {
    debugger;


    console.log("Form Data:", this.createAppointmentForm.value);
    if (this.createAppointmentForm.valid) {
      this.createAppointmentForm.enable();
      this.disableOrEnableForm(0);
      let formDataValues = this.createAppointmentForm.value;
      let slotObj = this.allSlotsData.find(
        (o) => o.slotId == formDataValues.appointmentSlot
      );
     
      console.log(this.selectedUHIDDetails["utm_source"], "test");
      let payload = {
        Leadsource: this.selectedUHIDDetails["utm_source"]
          ? this.selectedUHIDDetails["utm_source"]
          : this.currentUser["leadSource"] != null
          ? this.currentUser["leadSource"]
          : "AHLL-CRM", //"AngularAdmin-PhysicalAppointment",
        CRMLeadSource: formDataValues.appointmentReqMode,
        CityId: +formDataValues.city,
        AppointmentDate: CommonMethods.changeDateFormatDDMMYYYY(
          formDataValues.appointmentDate
        ),
        SlotId: slotObj.slotId,
        SlotTime: slotObj.slotTime,
        RelationTypeId: +formDataValues.relationTypeId,
        CountryCode: "91",
        PatientFirstName: formDataValues.patientFirstName,
        PatientLastName: formDataValues.patientLastName,
        PatientEmailId: formDataValues.email,
        DateOfBirth: CommonMethods.changeDateFormatDDMMYYYY(
          formDataValues.dateOfBirth
        ), //format yyyy/mm/dd
        Gender: +formDataValues.gender,
        PatientMobileNo: formDataValues.patientMobileNumber, //mobileNumber
        PatientUHID: this.selectedUHIDDetails.uhidNumber,
        IpAddress: "",
        AppointmentBookingToken: this.slotsData["appointmentBookingToken"],
        SpecialtyId: +formDataValues.speciality,
        // "DoctorId": +formDataValues.doctor,
        HospitalId: +formDataValues.clinic,
        CreatedIp: null,
        CreatedBy: 0,
        ContactId: 0,
        LeadAutoId: this.leadId,
        AppointmentRequestModeId: 0, //+formDataValues.appointmentReqMode,
        CallerAutoId: +this.callerStatusAutoId,
        CallStatusId: +this.selectedCallStatusId,
        StatusRemarks: formDataValues.statusRemarks,
        IsActivityLead:
          localStorage.getItem("IsActivityLead") == "true" ? true : false,
      };

      this.askApolloService.BookConsultationAppointment(payload).subscribe(
        (res: any) => {
          console.log("book:", res);
          if (res && res.isSuccess && res.response) {
            if (res.response && res.response["statusCode"] > 0) {
              this.messageService.showSuccess(res.response["message"]);
              this.callCenterService.afterCompleteOperationKnowTheStatus({
                callStatusId: this.selectedCallStatusId,
                callStatusName: this.selectedCallStatusName,
                isOperationDone: true,
                statusMessage: "Appointment Created Successfully.",
              });
            } else {
              this.messageService.showSuccess(res.response["message"]);
            }
          } else {
            this.messageService.showWarning(
              "Please Contact Admin, Server Issue !!!"
            );
          }
          this.disableOrEnableForm(1);
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to book appointment, An error occur while booking appointment."
          );
          this.disableOrEnableForm(1);
        }
      );
    } else {
      this.messageService.showWarning("Please Fill Fields");
    }
  }
 */
  healthCheckRes: any;
  healthCheckResKey: string;
  templeadSource: any;
  submitBookHealthCheck(formData) {
    if (this.createAppointmentForm.valid) {
      if (this.callType == 2) {
        this.currentUser = JSON.parse(
          localStorage.getItem("CurrentOutBoundCallMobileNumber")
        );
        this.templeadSource = this.selectedUHIDDetails["utm_source"]
          ? this.selectedUHIDDetails["utm_source"]
          : this.currentUser["leadSource"]
          ? this.currentUser["leadSource"]
          : "AHLL-CRM";
      } else if (localStorage.getItem("CurrentInBoundCallDetails") != null) {
        this.templeadSource = this.selectedUHIDDetails["utm_source"]
          ? this.selectedUHIDDetails["utm_source"]
          : "AHLL-CRM";
      }

      this.createAppointmentForm.enable();
      let formValues = this.createAppointmentForm.value;
      let selectedCity = this.citiesData.filter((c) => c.id == formValues.city);
      let slot = this.slotsData.filter(
        (c) => c.SlotId == formValues.appointmentSlot
      );
      let data = {
        isIndianNational: true,
        countryCode: "91",
        healthcheckName: this.healthChekDetails.HealthCheckName,
        hospitalId: +formValues.clinic,
        UHID: this.selectedUHIDDetails.uhidNumber
          ? this.selectedUHIDDetails.uhidNumber
          : "",
        cityId: formValues.city,
        cityName: selectedCity[0].name,
        dateOfBirth: CommonMethods.changeDateFormatDDMMYYYY(
          new Date(formValues.dateOfBirth)
        ),
        emailId: formValues.email,
        gender: +formValues.gender,
        leadSource: this.templeadSource, //"AngularAdmin-PhysicalAppointment",
        mobileNo: formValues.patientMobileNumber,
        patientFirstName: formValues.patientFirstName,
        patientLastName: formValues.patientLastName,
        appointmentDate: CommonMethods.changeDateFormatDDMMYYYY(
          formValues.appointmentDate
        ),
        slotId: slot[0].SlotId,
        slotTime: slot[0].SlotTime,
        apptRequestModeId: formValues.appointmentReqMode,
        tariff: this.healthChekDetails.PackagePrice,
        otherRemarks: formValues.statusRemarks,
      };
      //console.log(data);
      this.disableOrEnableForm(0);
      //debugger;
      this.healthCheckService.getBookHealthCheck(data).subscribe(
        (res: any) => {
          if (res && res.isSuccess && res.response) {
            this.healthCheckResKey = res.response["key"];
            //console.log(this.healthCheckResKey, "key Test");
            this.healthCheckService
              .bookHealthCheck(data, this.slotsTimeObj.appointmentBookingToken)
              .subscribe(
                (res) => {
                  this.disableOrEnableForm(1);
                  localStorage.removeItem("HC_JWT_TOKEN");
                  if (res && res.appointmentId > 0) {
                    this.healthCheckRes = res;
                    //console.log(this.healthCheckRes,"HCRes")
                    this.messageService.showSuccess(
                      "HC Appointment booked successfully, Appointment ID: " +
                        res.appointmentId
                    );
                    this.callCenterService.afterCompleteOperationKnowTheStatus({
                      callStatusId: this.selectedCallStatusId,
                      callStatusName: this.selectedCallStatusName,
                      isOperationDone: true,
                      statusMessage: "HC Appointment Created Successfully.",
                    });
                    this.getUpdateHealthCheck();
                    this.UpdateCallStatusDetails();
                  } else {
                    this.messageService.showErrorMessage(res.errorMsg);
                  }
                },
                (err) => {
                  localStorage.removeItem("HC_JWT_TOKEN");
                  this.disableOrEnableForm(1);
                  if (err.status === 401) {
                    this.messageService.showErrorMessage(
                      "Your session has been expired."
                    );
                  } else if (err.status === 400) {
                    this.messageService.showErrorMessage(err.error.Message);
                  } else {
                    this.messageService.showErrorMessage(
                      "Something went wrong"
                    );
                  }
                }
              );
          } else {
            this.messageService.showErrorMessage(res.errorMsg);
          }
        },
        (err) => {
          if (err.status === 401) {
            this.messageService.showErrorMessage(
              "Your session has been expired."
            );
          } else if (err.status === 400) {
            this.messageService.showErrorMessage(err.error.Message);
          } else {
            this.messageService.showErrorMessage("Something went wrong");
          }
        }
      );
    }
  }

  getUpdateHealthCheck() {
    this.healthCheckService
      .getUpdateHealthCheck(this.healthCheckResKey, this.healthCheckRes)
      .subscribe(
        (res: any) => {
          console.log(res.response, "final");
          this.messageService.showSuccess(res.response["statusMessage"]);
        },
        (err) => {
          if (err.status === 401) {
            this.messageService.showErrorMessage(
              "Your session has been expired."
            );
          } else if (err.status === 400) {
            this.messageService.showErrorMessage(err.error.Message);
          } else {
            this.messageService.showErrorMessage("Something went wrong");
          }
        }
      );
  }

  getAgeFromDOB(date: Date): number {
    try {
      let currYear = new Date().getFullYear();
      let dobYear = date.getFullYear();
      let age = currYear - dobYear;
      return age;
    } catch (e) {
      return 0;
    }
  }

  verifyAgeCritaria(minAge, maxAge, ageFilter, patientAge) {
    console.log("----minAge----");
    console.log(minAge);
    console.log("----maxAge----");
    console.log(maxAge);
    console.log("----patientAge----");
    console.log(patientAge);
    if (patientAge > minAge && patientAge <= maxAge) {
      return true;
    } else {
      return false;
    }
  }

  UpdateCallStatusDetails() {
    //this.resetPkgEnquiryForm = false;
    let time = "";
    let date = "";
    let payload = {
      AutoId: this.callerStatusAutoId,
      CallStatus: 35,
      CallSubStatus: 66,
      Remarks: "Booked",
      CallbackRequestDate: date,
      CallbackRequestTime: time,
      IsActivityLead:
        localStorage.getItem("IsActivityLead") == "true" ? true : false,
    };
    this.callCenterService.UpdateCallStatusDetails(payload).subscribe(
      (res: any) => {},
      (error) => {}
    );
  }

  disableOrEnableForm(flag) {
    // 1 enable , 0 disable
    if (flag == 1) {
      this.loadingFlag = false;
      //this.ref.detectChanges();
      //this.createAppointmentForm.enable();
    } else {
      this.loadingFlag = true;
      //this.createAppointmentForm.disable();
    }
  }
  // controls validation
  public hasError = (controlName: string, errorName: string) => {
    return this.createAppointmentForm.controls[controlName].hasError(errorName);
  };

  appendZeroWhenSingleDigitInTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  getTimeOnly(givenDate) {
    var today = new Date(givenDate);
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    // add a zero in front of numbers<10
    m = this.appendZeroWhenSingleDigitInTime(m);
    s = this.appendZeroWhenSingleDigitInTime(s);
    return h + ":" + m + ":" + s;
  }
}
